
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.575 14.045a.415.415 0 01-.588 0 .418.418 0 010-.59l3.425-3.439-3.457-3.47a.418.418 0 010-.59.415.415 0 01.588 0L10 9.426l3.457-3.47a.415.415 0 01.588 0 .418.418 0 010 .59l-3.457 3.47 3.425 3.439a.418.418 0 010 .59.415.415 0 01-.588 0L10 10.607l-3.425 3.438z","fill":"#3C464F"}})])
          )
        }
      }
    